import {Component, Input, OnInit, SimpleChanges, OnChanges, Inject} from '@angular/core';
import { first } from 'rxjs/operators';
import { Task } from '@app/_components/task';
import { TaskService } from '@app/_components/task';
import { AlertService, AuthenticationService } from '@app/_services';
import { Router } from '@angular/router';
import {SelectItem, LazyLoadEvent, MessageService, TreeNode} from 'primeng/api';
import { Subscription } from 'rxjs';
import { User, ApiResponse } from '@app/_models';
import { UserService } from '@app/_services';
import { TaskTypeEnum, NextActionEnum } from '@app/_helpers';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {TaskComponent} from '@app/_components/task/task/task.component';
import {TagJoinService} from '@app/_components/_helpers/tag-join/tag-join.service';
import {Inbox} from '@app/_components/inbox';
import {InboxComponent} from '@app/_components/inbox/inbox/inbox.component';

@Component({
    selector: 'app-public-task-list',
    templateUrl: './public-task-list.component.html',
    styleUrls: ['./public-task-list.component.css'],
    standalone: false
})
export class PublicTaskListComponent implements OnInit, OnChanges {

  @Input() taskTag: any;
  @Input() popupMode = true;
	@Input() taskSource: any;
	@Input() taskSourceId: any;
	@Input() passedTaskName: any;
  private taskSummary: any = {};
  private priorityButtons: SelectItem[];
  private selectedPriority: number;
  private taskSummarySubscription: Subscription;
  statuses: any;
	loadTaskForMailId: any;
  loadStatusEnabled = false;
  usersSearch: any[] = [];
  showOpenSummary = false;
  taskApiData: any;
	get taskTypeEnum() { return TaskTypeEnum; }
	get nextActionEnum() { return NextActionEnum; }

	currentUser: User;
	currentUserSubscription: Subscription;

	// list
	datasource: Task[];
	task: Task;
	tasks: Task[] = [];
	taskList: any[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

  @Input() showFilter = true;
  @Input() showPagination = true;
  @Input() outlineNewButton = true;
  @Input() loadChild = false;
  @Input() inputTask: any;

	columns: any[] = [
		{ field: 'dateDue', header: 'Due Date', width: '10%' },
		{ field: 'name', header: 'Name', width: '20%' },
    { field: 'assignedToUserVO.lastName', header: 'Assigned To', width: '10%' },
		{ field: 'createdByUserVO.lastName', header: 'Author', width: '10%' },
		{ field: 'dateToFollowup', header: 'Followup Date', width: '12%' },
		{ field: 'dateCreated', header: 'Created', width: '10%' },
		{ field: 'dateCompleted', header: 'Completed', width: '10%' },
		{ field: 'status', header: 'Status', width: '15%' },
	];

  assignedSearchToUser: any;
  createdBySearchToUser: any;
  selectedStatusFilter = [1, 2];
  selectedFilterName = '';
  selectedFilterTagSearch = '';
  selectedFilterCategory = '';
  activefilter: any[] = [];
  activefilterstr: any[] = [];
  formLoading = false;
  selectedNode: TreeNode;
  items: any[];
  taskTagSelected = '';
  filters: any;
  activeFilterMap: any = {
    'createdByUserVO.userId' : 'Author',
    'assignedToUserVO.userId' : 'Assigned To',
    'status': 'status',
    'name' : 'name',
    'taskId': 'Category/tags',
    'tagList' : 'Category',
    'priority' : 'priority',
	'loadstatus' : 'Include Status Report'
  };

	constructor(
		private userService: UserService,
		private authenticationService: AuthenticationService,
		private taskService: TaskService,
    private tagJoinService: TagJoinService,
		private alertService: AlertService,
		private router: Router,
		private messageService: MessageService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any
	) {
    this.statuses = taskService.statuses;
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
      this.priorityButtons = [];
		});
		if ( data){
			this.showPagination = data?.showPagination;
			this.outlineNewButton = data?.outlineNewButton;
			this.loadTaskForMailId = data?.parentMsgId;
      this.taskSource = data?.taskSource;
      this.showFilter = data?.showFilter;
		}
    this.filters = { 'status': {'value': [1, 2], 'matchMode': 'in'} };
	}

	ngOnInit() {
    this.refreshSummaryCounts();
    this.findUsersWith('');
    this.items = [
      {
        label: 'Copy Task',
        icon: 'pi pi-fw pi-copy',
        command: (event) => this.openTaskForClone()
      },
      {
        label: 'Sub Task',
        icon: 'pi pi-fw pi-clone',
        command: (event) => this.openTaskForSubTask()
      },
      {
        label: 'Mail Task',
        icon: 'pi pi-fw pi-envelope',
        command: (event) => this.openMailTask()
      },
      {
        label: 'Summary',
        icon: 'pi pi-fw pi-search',
        command: (event) => this.openSummary()
      },
      /*{
        separator: true
      },*/
    ];
  }

  private refreshSummaryCounts() {
    this.taskSummarySubscription = this.taskService.currentTaskSummary.subscribe(taskSumaary => {
      this.taskSummary = taskSumaary;
      let prtCnt = [ 0, 0, 0, 0, 0, 0 ];
      for (let i = 0; i < this.taskSummary.priorityCount?.length; i++) {
        prtCnt[this.taskSummary?.priorityCount[i]?.priority] = this.taskSummary?.priorityCount[i]?.count;
      }
      this.priorityButtons = [];
      this.priorityButtons.push({value: 1, label: 'Critical(' + prtCnt[1] + ')', icon: 'fa fa-search', styleClass: 'p-button-danger'});
      this.priorityButtons.push({value: 2, label: 'Immediate (' + prtCnt[2] + ')', styleClass: 'p-button-warning'});
      this.priorityButtons.push({value: 3, label: 'Important (' + prtCnt[3] + ')', styleClass: 'p-button-success'});
      this.priorityButtons.push({value: 4, label: 'Standard (' + prtCnt[4] + ')', styleClass: 'p-button-info'});
      this.priorityButtons.push({value: 5, label: 'Low (' + prtCnt[5] + ')', styleClass: 'p-button-primary'});
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
		for (let propertyName in changes) {
			if (propertyName && propertyName === 'taskTag') {
				console.log('changes!!!! ' + propertyName + ' ' + JSON.stringify(changes));
				console.log('changes22222!!!! ' + JSON.stringify(this.taskTag));
				this.loadLazy(this.lazyLoadEvent);
			}
		}
	}

	getFilteredTags(tags, selectedTag) {
		// if filter text input is empty then load all records
		if ( !selectedTag){
			this.taskTag = null;
		}
		if (tags == '0') {
			delete this.lazyLoadEvent.filters.taskId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			// If records found then show filtered records
			if (tags.length > 0) {
				// if filter text input is not empty then load filtered records only
				let retrivedTasks = [];
				tags.forEach(tag => {
					retrivedTasks.push(tag.tagSourceId);
				});
        this.lazyLoadEvent.filters.taskId = { 'value': retrivedTasks, 'matchMode': 'in' };
				this.loadLazy(this.lazyLoadEvent);
			} else {
				// Display empty table as no record found with filtered input
				this.tasks = [];
        this.taskList = [];
        this.recordTotal = 0;
			}
		}
	}

	addFilterTag(event) {
		console.log('addFilterTag!!!! ' + JSON.stringify(event));
	}

	deleteFilterTag(event) {
		console.log('deleteFilterTag!!!! ' + JSON.stringify(event));
	}



	addUser(): void {
		this.router.navigate(['user-add']);
	}

	loadLazy(event: LazyLoadEvent) {
		if (this.loadChild && this.inputTask) {
			event.filters = {};
			event.filters['parentTaskId'] = {};
			event.filters['parentTaskId'].value = this.inputTask.taskId;
			event.filters['parentTaskId'].matchMode = 'in';
		} else if (this.loadTaskForMailId && this.loadTaskForMailId > 0) {
			event.filters = {};
			event.filters['msgVO.msgId'] = {};
			event.filters['msgVO.msgId'].value = this.loadTaskForMailId;
			event.filters['msgVO.msgId'].matchMode = 'in';
		}

		// default sort
		if (event && !event.multiSortMeta) {
			event.multiSortMeta = [];
			event.multiSortMeta.push({field: 'dateDue', order: -1});
			event.multiSortMeta.push({field: 'dateCreated', order: 0});
		}
		if (this.selectedPriority) {
			event.filters.priority = {'value': this.selectedPriority, 'matchMode': 'in'};
		}
		if ( this.loadStatusEnabled ){
			event.filters.loadstatus = {'value': this.loadStatusEnabled, 'matchMode': 'in'};
		}
		else{
			delete event.filters.loadstatus;
		}
    if ( this.taskSource){
      event.filters.taskSource = {'value': this.taskSource, 'matchMode': 'in'};
    }
    if ( this.taskSourceId){
      event.filters.taskSourceId = {'value': this.taskSourceId, 'matchMode': 'in'};
    }

		this.activefilter = [];
		for (let prop in event.filters) {
			let dispayName: string = this.activeFilterMap[prop] + ':' + event.filters[prop].value;
			switch (prop) {
				case 'taskId':
					dispayName = this.taskTag ? 'Category:' + this.taskTag?.name : 'Tags';
					break;
				case 'status':
					dispayName = 'status: ';
					let selectedStatus = event.filters[prop]?.value;
					for (let i = 0; i < selectedStatus?.length; i++) {
						dispayName = dispayName + ' ' + this.statuses[selectedStatus[i]]?.name;
					}
			}
			let entry: any = {'name': prop, 'displayName': dispayName, 'value': event.filters[prop]};
			this.activefilter.push(entry);
		}

		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
		 	);

			const pageNumber = Math.round(event.first / event.rows);
			this.taskService.findPublicTasksByFilterSummary(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					apiResponse => {
						// console.log('tasks are: ' + JSON.stringify(apiResponse));
						this.datasource = apiResponse.data.users;
						this.recordTotal = apiResponse.page.recordTotal;
						this.tasks = apiResponse.data.tasks;
            this.taskList = [];
            for (let i = 0; i < this.tasks.length; i++){
              let node = {
                'data': this.tasks[i],
				  leaf: false
              };
              this.taskList.push(node);
            }
					},
					apiResponse => {
						console.log('USER LIST!: ' + JSON.stringify(apiResponse));
						this.alertService.error(apiResponse);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.tasks = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	onRowSelect(event) {

		this.onOpenFormEdit(event.data);
	}
	/*********
	 * Edit Button
	 *
	 */

	onOpenFormEdit(task: Task) {

		const dialogConfig = new MatDialogConfig();

		// settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = "100vw";
    dialogConfig.maxHeight = "100vh";
		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			task: task,
			title: '',
			taskApi: task,
      isModal: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				// dialogRef.close();
			});

		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doaddAndDontClose.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);

			});

		dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.updateTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.deleteTestCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}
	updateTaskCB(task: Task) {
		console.log('Updating Test: ' + JSON.stringify(task));
		let itemIndex = this.tasks.findIndex((item: any) => item.taskId === task.taskId);
		this.tasks[itemIndex] = task;

		// no idea what this is but it is required to update the array
		this.tasks = [...this.tasks];
    let node = {'data': task, leaf: false };
    this.taskList[itemIndex] = node;
    this.taskList = [...this.taskList];
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test ' + task.taskId + ' Updated', life: 3000 });
	}

	daysFromToday(date: Date): any {
		let today = new Date();
		let dateDue = new Date(date);
		if (dateDue.valueOf() === 0) { return ''; }
		// console.log(today.valueOf());
		// console.log(dateDue.valueOf());
		return Math.ceil((dateDue.getTime() - today.getTime()) / (1000 * 3600 * 24));
	}

	daysFromTodayAbs(date: Date): any {
    if ( !date) { return ''; }
		let today = new Date();
		let dateDue = new Date(date);
		if (dateDue.valueOf() === 0) { return ''; }
		return Math.abs(Math.ceil((today.getTime() - dateDue.getTime() ) / (1000 * 3600 * 24)));
	}
  daysFromTodayAbsDue(date: Date): any {
    if ( !date){
      return 0;
    }
    let today = new Date();
    let dateDue = new Date(date);
    if (dateDue.valueOf() === 0) { return 0; }
    return Math.ceil((today.getTime() - dateDue.getTime() ) / (1000 * 3600 * 24));
  }
  daysFromTodayAbsDueFloor(date: Date): any {
    if ( !date){
      return 0;
    }
    let today = new Date();
    let dateDue = new Date(date);
    if (dateDue.valueOf() === 0) { return 0; }
    return Math.floor((today.getTime() - dateDue.getTime() ) / (1000 * 3600 * 24));
  }


	priorityColor(dueDate: Date): any {
		if (this.daysFromToday(dueDate) === 0) { return 'pink'; }
		if (this.daysFromToday(dueDate) > 0 && this.daysFromToday(dueDate) < 3) { return 'lightyellow'; }
		if (this.daysFromToday(dueDate) < 0) { return 'red'; }
		return 'transparent';
	}

	reloadPage() {
		window.location.reload();
	}
  reloadSummaryCount() {
    this.taskService.getTaskSummary(this.currentUser.userId).subscribe(dataCount =>
    {
      this.refreshSummaryCounts();
    });

  }
  loadWithParam(type: string) {
    this.loadLazyForSummary(this.lazyLoadEvent, type);
  }
  loadLazyForSummary(event: LazyLoadEvent, type: string) {
    event = this.lazyLoadEvent;
    if (event && !event.multiSortMeta) {
      event.multiSortMeta = [];
      event.multiSortMeta.push({ field: 'dateCreated', order: 0 });
    }
    // if filtering by tagId
    if (this.taskTag) {
      event.filters.tagList = { 'value': this.taskTag, 'matchMode': 'in' };
    }

    try {
      this.loading = true;
      this.lazyLoadEvent = event;

      console.log(
        ' event.first:' + event.first
        + '  |  event.rows:' + event.rows
        + '  |  event.sortField:' + event.sortField
        + '  |  event.sortOrder:' + event.sortOrder
        + '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
        + '  |  event.globalFilter:' + event.globalFilter
        + '  |  event.filters:' + JSON.stringify(event.filters)
      );

      const pageNumber = Math.round(event.first / event.rows);
      this.taskService.findByTaskListSummary(
        pageNumber, event.rows,
        event.sortField,
        event.sortOrder,
        event.multiSortMeta,
        event.globalFilter,
        event.filters, this.currentUser.userId, type).pipe(first()).subscribe(

        apiResponse => {
			// console.log('tasks are: ' + JSON.stringify(apiResponse));
			this.datasource = apiResponse.data.users;
			this.recordTotal = apiResponse.page.recordTotal;
			this.tasks = apiResponse.data.tasks;
			this.taskList = [];
			for (let i = 0; i < this.tasks.length; i++) {
				let node = {
					'data': this.tasks[i],
					leaf: false
				};
				this.taskList.push(node);
			}
		},
        apiResponse => {
          console.log('USER LIST!: ' + JSON.stringify(apiResponse));
          this.alertService.error(apiResponse);
        },
        () => { this.loading = false; }
      );

      if (this.datasource) {
        this.tasks = this.datasource.slice(event.first, (event.first + event.rows));
      }
    } catch (error) {
      console.log('loadLazy(' + event + ')' + error);
    }
  }

  loadLazyForPriority(event: any) {
    this.selectedPriority = event.value.value;
    this.lazyLoadEvent.filters = {};
    this.loadLazy(this.lazyLoadEvent);
  }
  getStatusName(taskApi: any) {
    if (taskApi && taskApi?.status !== undefined) {
      const status = this.statuses.find((e: any) => e.value === taskApi?.status);
      return status.name;
    } else {
      return '';
    }
  }

	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = "100vw";
    dialogConfig.maxHeight = "100vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Task',
      isModal: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
				// close the dialogBox
				dialogRef.close();
			});
	}
	addTaskCB(task: Task) {
		console.log('Adding Test: ' + JSON.stringify(task));
		// if we don't have a tests array yet...
		if (!this.tasks) {
			this.tasks = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.tasks.unshift(task);

		// no idea what this is but it is required to update the array
		this.tasks = [...this.tasks];
    let node = {'data': task, leaf: false };
    this.taskList.unshift(node);
    this.taskList = [...this.taskList];
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Test ' + task.taskId + ' Added', life: 3000 });
	}

    getNumnerOfTask(task: any) {
		if (!task?.jsonChildTask){
			return 0;
		}
		return JSON.parse(task?.jsonChildTask).length;
    }
	getNumnerOfTasks(rowData: any) {
    let allowedChild: Task[] = [];
    for ( let i =  0; i < rowData?.children?.length; i++){
      let child = rowData?.children[i];

      if ( this.currentUser.userId === child.assignedTo?.userId || this.currentUser.userId === child.createdBy?.userId ||
        this.currentUser.userId === child.ownedBy?.userId ) {
        allowedChild.push(child);
        continue;
      }
        for ( let j =  0; j < child.taskUsers?.length; j++){
          if ( this.currentUser.userId === child.taskUsers[j]?.userId){
            allowedChild.push(child);
            break;
          }
        }
    }
		return allowedChild.length;
	}
  getColorForDue(task: any) {
    let color = 'white';
    if ( !task || !task?.dateDue){
      return color;
    }
    if ( this.daysFromTodayAbsDueFloor(task?.dateDue)  > 0){
      color = '#d7164d';
    }
    else if ( this.daysFromTodayAbsDueFloor(task?.dateDue)  < 0){
      color = '#11a145';
    }
    else{
      color = 'blue';
    }
    return color;
  }
  addTask(tasktypeId: any) {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = "100vw";
    dialogConfig.maxHeight = "100vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    let task: any = new Task();
    task.name = this.passedTaskName;
    task.visibility = 1;
    task.taskSource = this.taskSource;
    task.taskSourceId = this.taskSourceId;
    dialogConfig.data = {
      title: 'Add Task',
      taskTypeId: tasktypeId,
      isModal: true,
      taskApi: task
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        this.addTaskCB(data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdateAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
  }
  onNodeExpand(event: any) {
    const node = event.node;
    let subtaskList = [];
    let tasks = node?.data?.children;
    for (let i = 0; i < tasks.length; i++){
      if ( this.currentUser.userId === tasks[i]?.assignedTo?.userId || this.currentUser.userId === tasks[i]?.createdBy?.userId ||
        this.currentUser.userId === tasks[i]?.ownedBy?.userId ) {
        tasks[i].ischild = true;
        let entry = {
          'data': tasks[i],
          leaf: false,
        };
        subtaskList.push(entry);
      }

    }
    node.children = subtaskList;
    this.taskList = [...this.taskList];
  }

  // keeping older node expand for reference
  onNodeExpand1(event: any) {
	  const node = event.node;
	  const childTask = [];
	  let lazyLoadEvent1: LazyLoadEvent = this.lazyLoadEvent;
	  lazyLoadEvent1.filters = {};
	  lazyLoadEvent1.filters['parentTaskId'] = {};
	  lazyLoadEvent1.filters['parentTaskId'].value = node?.data?.taskId;
	  lazyLoadEvent1.filters['parentTaskId'].matchMode = 'in';
	  this.taskService.findByFilterSummary(
		  0, 200,
		  lazyLoadEvent1.sortField,
		  lazyLoadEvent1.sortOrder,
		  lazyLoadEvent1.multiSortMeta,
		  lazyLoadEvent1.globalFilter,
		  lazyLoadEvent1.filters).pipe(first()).subscribe(

		  apiResponse => {
			  // console.log('tasks are: ' + JSON.stringify(apiResponse));
			  this.datasource = apiResponse.data.users;
			  this.recordTotal = apiResponse.page.recordTotal;
			  this.tasks = apiResponse.data.tasks;
			  let subtaskList = [];
			  for (let i = 0; i < this.tasks.length; i++){
				  this.tasks[i].ischild = true;
				  let entry = {
					  'data': this.tasks[i],
					  leaf: false,
				  };
				  subtaskList.push(entry);
			  }
			  node.children = subtaskList;
			  this.taskList = [...this.taskList];
		  },
		  apiResponse => {
			  console.log('USER LIST!: ' + JSON.stringify(apiResponse));
			  this.alertService.error(apiResponse);
		  },
		  () => { this.loading = false; }
	  );
  }
  findUsersWith(queryString: string)
  {
    this.userService.findUsersWith(queryString).pipe(first()).subscribe(

      data =>
      {
        console.log('taskUser serach: ' + JSON.stringify(data));
        this.usersSearch = data.data.userSummaryList;
       this.usersSearch.forEach(user => {
          if ( !user.lastName) { user.lastName = ''; }
          if ( !user.firstName) { user.firstName = ''; }
          user.fullName = user.lastName + ' ' + user.firstName;
        });
        // console.log('QA: ' + JSON.stringify(this.taskUserSuggestions));
      },
      error =>
      {
        // console.log('reports LIST!: ' + JSON.stringify(error));
        this.alertService.error(error);
      },
      () =>
      { }
    );
  }

  onTagSelect(event: any) {
    this.taskTag = event;

      if ( this.taskTag ) {
        this.tagJoinService.findTagsWithType(this.taskTag?.name, 40, this.taskTag?.tagType).pipe(first()).subscribe(
          res =>
          {
            console.log(res.data.tagJoin);
            this.getFilteredTags(res.data.tagJoin, this.taskTag);
          },
          error =>
          {
            // console.log('reports LIST!: ' + JSON.stringify(error));
            this.alertService.error(error);
          },
          () =>
          { }
        );
      } else {
        this.getFilteredTags('0', this.taskTag);
      }
  }
  openCm(event, cm, rowNode) {
    event.preventDefault();
    event.stopPropagation();
    cm.show(event);
    this.selectedNode = rowNode?.node;
    return false;
  }
  openSummary() {
    this.taskApiData = this.selectedNode.data;
    this.showOpenSummary = true;
  }
  openMailTask() {
    let taskApi = this.selectedNode.data;
    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    let inbox = new Inbox();
    inbox.subject = taskApi.name;
    inbox.senderEmail = taskApi?.assignedTo?.emailAddress;
    inbox.emailHtml = this.getTaskMailContent( taskApi );
    inbox.emailText = this.getTaskMailContent( taskApi );
    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      inbox: inbox,
      title: 'Mail Task Details',
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(InboxComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        this.alertService.success('Mail Sent', true);
        console.log('Dialog output:', data);
        dialogRef.close();
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        this.alertService.success('Mail Sent', true);
        console.log('Dialog output:', data);
        dialogRef.close();
      });
  }
  getTaskMailContent(taskApi: any) {
    let taskLink = 'https://admin.kbmhawaii.com/task-view/' + taskApi?.taskId ;
    let emailHTML =  '<h4>Hi, Please find task details</h4> <br><br><table>' +
      '<tr><th colspan="1">Task assigned</th><th colspan="5"><a href="' + taskLink + '" targrt="_blank">Click here to view task</a></th></tr>' +
      '<tr><td>Task Name</td><td> ' + this.makeSafe(taskApi.name) + '</td></tr>' +
      '<tr><td>Due Date</td><td> ' + this.makeSafe(taskApi.dateDue) + '</td></tr>' +
      '<tr><td>Created By</td><td> ' + this.makeSafe(taskApi?.createdBy?.lastName) + ' , ' + this.makeSafe(taskApi?.createdBy?.firstName) + '</td></tr>' +
      '<tr><td>Owned By</td><td> ' + this.makeSafe(taskApi?.ownedBy?.lastName) + ' , ' + this.makeSafe(taskApi?.ownedBy?.firstName) + '</td></tr>' +
      '<tr><td>Due Date</td><td> ' + this.makeSafe(taskApi.dateDue) + '</td></tr>' +
      '<tr><td>Status</td><td> ' + this.getStatusName(taskApi) + '</td></tr>' +
      '<tr><td>Doc</td><td> ' + this.makeSafe(taskApi?.miniDoc) + '</td></tr>' +
      '</table>';
    return emailHTML;
  }
  makeSafe(val: any){
    return val ? val : '';
  }
  openTaskForClone() {
    let task = this.selectedNode.data;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = "100vw";
    dialogConfig.maxHeight = "100vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    let passingTask: any = new Task();
    Object.assign(passingTask, task);
    passingTask.jsonChildTask = null;
    passingTask.taskId = null;
    passingTask.miniDoc = null;
    dialogConfig.data = {
      title: 'Copy Task',
      isModal: true,
      taskApi: passingTask,
      purpose: 'clone',
      copyfromtaskid:  task.taskId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doaddAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });

  }
  openTaskForSubTask() {
    let task = this.selectedNode.data;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.width = '100vw';
    dialogConfig.height = '100vh';
    dialogConfig.maxWidth = "100vw";
    dialogConfig.maxHeight = "100vh";

    // pass data, ie rateBuicket: this.shortTermRentalId,
    let passingTask: any = new Task();
    Object.assign(passingTask, task);
    passingTask.name = '';
    passingTask.taskId = null;
    passingTask.parentTaskId = task?.taskId;
    passingTask.msgId = task.msgId;
    passingTask.jsonChildTask = null;
    passingTask.miniDoc = null;
    dialogConfig.data = {
      title: 'Assign Task',
      isModal: true,
      taskApi: passingTask,
      purpose: 'clone',
      copyfromtaskid:  task?.taskId
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(TaskComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doUpdate.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });
    dialogRef.componentInstance.doaddAndDontClose.subscribe(
      data => {
        console.log('Dialog output:', data);
        this.loadLazy(this.lazyLoadEvent);
      });

  }
  fullName(user: any){
    let fullName = '';
    if ( user?.firstName ){
      fullName = fullName + user?.firstName + ' ';
    }
    if ( user?.lastName ){
      fullName = fullName + user?.lastName;
    }
    return fullName;
  }
  changeInplaceData(event, taskApi){
    let updatedStatus = event?.value;
    let newEvent: any = {};
    taskApi.status = updatedStatus;
    newEvent.data = taskApi;
    newEvent.field = 'status';
    this.onCellEditComplete(newEvent);
  }
  onCellEditInit(event: any): void { }
  onCellEditComplete(event: any): void {
    let rowData = event.data;
    this.taskService.findById(rowData.taskId).subscribe(
      res => {
        console.log('task-find SUCCESS: ' + JSON.stringify(res));
        let fullTaskObject = res.data.task;
        fullTaskObject[event.field] = rowData[event.field];
        this.formUpdate(fullTaskObject);
      });
  }
  onCellEditCancel(): void { this.messageService.add({ severity: 'info', summary: 'Update Canceled', detail: 'No changes were saved' }); }
  formUpdate(task: Task){
      console.log('Task: Updating...' + JSON.stringify(task));
      this.taskService.update(task)
        .pipe(first())
        .subscribe(
          res =>
          {
            console.log('Task-Update SUCCESS: ' + JSON.stringify(res));
            this.alertService.success(res, true);
          },
          err =>
          {
            console.log('Task-Update FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () =>
          {
            this.formLoading = false;
          });
  }
  removedFilter(removedChip: any){
    console.log(removedChip);
    delete this.lazyLoadEvent.filters[removedChip.value?.name];
      switch (removedChip.value?.name) {
          case 'status':
              this.selectedStatusFilter = [];
              break;
          case 'name':
              this.selectedFilterName = '';
              break;
          case 'taskId':
              this.taskTagSelected = '';
              this.selectedFilterTagSearch = '';
			  this.taskTag = null;
              break;
          case 'createdByUserVO.userId':
              this.createdBySearchToUser = null;
              break;
          case 'assignedToUserVO.userId':
              this.assignedSearchToUser = null;
              break;
          case 'tagList':
              this.taskTag = null;
              break;
		  case 'loadstatus':
			  this.loadStatusEnabled = false;
			  break;
      }
    this.loadLazy(this.lazyLoadEvent);
  }

}

